export const LANGUAGES = [
  {
    CODE: 'en',
    NAME: 'English (United States)'
  },
  {
    CODE: 'de',
    NAME: 'German'
  },
  {
    CODE: 'ja',
    NAME: 'Japanese'
  },
  {
    CODE: 'ru',
    NAME: 'Russian'
  },
  {
    CODE: 'fa',
    NAME: 'فارسی'
  }
];

export const MANWOM = [
  {
    CODE: 'FEMALE',
    NAME: 'Female'
  },
  {
    CODE: 'MALE',
    NAME: 'Male'
  }
];

export const DEFAULTS = {
  MALEFEMALE: MANWOM[0].CODE,
  LANGUAGES: LANGUAGES[4].CODE,
  SPEED: 0,
  TEXT: '',
  SPEECH: null
}
